<template>
  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 2.96243 2.96243 0.5 6 0.5ZM5.5 3C5.22386 3 5 3.22386 5 3.5V6.5C5 6.77614 5.22386 7 5.5 7H8C8.27614 7 8.5 6.77614 8.5 6.5C8.5 6.22386 8.27614 6 8 6H6V3.5C6 3.22386 5.77614 3 5.5 3Z"
      fill="currentColor"
    />
  </svg>
</template>
